module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-bold.woff
// module id = Qgw/
// module chunks = 0